"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenInFull = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var OpenInFull = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21.75 11.25a.75.75 0 01-.75-.75V3h-7.5a.75.75 0 01-.75-.75V.75A.75.75 0 0113.5 0h9.75a.75.75 0 01.75.75v9.75a.75.75 0 01-.75.75h-1.5zm-10.5 12a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75V13.5a.75.75 0 01.75-.75h1.5a.75.75 0 01.75.75V21h7.5a.75.75 0 01.75.75v1.5z", clipRule: "evenodd" })); };
exports.OpenInFull = OpenInFull;
//# sourceMappingURL=open-in-full.js.map